var map = {
	"./background.png": "b874",
	"./bronze_shine.png": "ffff",
	"./crown.png": "8dce",
	"./crown_bg_liveflamingo.png": "658e",
	"./crown_bg_red.png": "ae91",
	"./crown_bg_superlive.png": "d1f7",
	"./delete-accounts-spl.png": "c1b0",
	"./download-on-apple.png": "fbfa",
	"./download-on-google.png": "d79f",
	"./empty_profile.png": "2f0f",
	"./flags/flag_afghanistan.png": "5233",
	"./flags/flag_aland.png": "a792",
	"./flags/flag_albania.png": "3bf9",
	"./flags/flag_algeria.png": "5b3f",
	"./flags/flag_american_samoa.png": "c18e",
	"./flags/flag_andorra.png": "93d1",
	"./flags/flag_angola.png": "416e",
	"./flags/flag_anguilla.png": "d866",
	"./flags/flag_antarctica.png": "8140",
	"./flags/flag_antigua_and_barbuda.png": "c2d2",
	"./flags/flag_argentina.png": "9762",
	"./flags/flag_armenia.png": "a4d8",
	"./flags/flag_aruba.png": "ebde",
	"./flags/flag_australia.png": "4be9",
	"./flags/flag_austria.png": "7a88",
	"./flags/flag_azerbaijan.png": "728c",
	"./flags/flag_bahamas.png": "3ff3",
	"./flags/flag_bahrain.png": "a100",
	"./flags/flag_bangladesh.png": "c2b6",
	"./flags/flag_barbados.png": "da7e",
	"./flags/flag_belarus.png": "52db",
	"./flags/flag_belgium.png": "460e",
	"./flags/flag_belize.png": "63ef",
	"./flags/flag_benin.png": "d6a8",
	"./flags/flag_bermuda.png": "67a0",
	"./flags/flag_bhutan.png": "3387",
	"./flags/flag_bolivia.png": "81ea",
	"./flags/flag_bosnia.png": "208f",
	"./flags/flag_botswana.png": "3d24",
	"./flags/flag_brazil.png": "96f2",
	"./flags/flag_british_indian_ocean_territory.png": "e38c",
	"./flags/flag_british_virgin_islands.png": "856f",
	"./flags/flag_brunei.png": "4ff0",
	"./flags/flag_bulgaria.png": "a15b",
	"./flags/flag_burkina_faso.png": "31d2",
	"./flags/flag_burundi.png": "56c1",
	"./flags/flag_cambodia.png": "f4f1",
	"./flags/flag_cameroon.png": "28a0",
	"./flags/flag_canada.png": "3ada",
	"./flags/flag_cape_verde.png": "01d3",
	"./flags/flag_cayman_islands.png": "e649",
	"./flags/flag_central_african_republic.png": "8a16",
	"./flags/flag_chad.png": "ace1",
	"./flags/flag_chile.png": "208b",
	"./flags/flag_china.png": "2eed",
	"./flags/flag_christmas_island.png": "5012",
	"./flags/flag_cocos.png": "deac",
	"./flags/flag_colombia.png": "84dd",
	"./flags/flag_comoros.png": "3328",
	"./flags/flag_cook_islands.png": "8720",
	"./flags/flag_costa_rica.png": "fcd6",
	"./flags/flag_cote_divoire.png": "2a41",
	"./flags/flag_croatia.png": "af3b",
	"./flags/flag_cuba.png": "a116",
	"./flags/flag_curacao.png": "0ca8",
	"./flags/flag_cyprus.png": "ebf9",
	"./flags/flag_czech_republic.png": "88a2",
	"./flags/flag_democratic_republic_of_the_congo.png": "773b",
	"./flags/flag_denmark.png": "0f4f",
	"./flags/flag_djibouti.png": "5a4c",
	"./flags/flag_dominica.png": "5b54",
	"./flags/flag_dominican_republic.png": "e219",
	"./flags/flag_ecuador.png": "13ed",
	"./flags/flag_egypt.png": "c650",
	"./flags/flag_el_salvador.png": "937f",
	"./flags/flag_equatorial_guinea.png": "d427",
	"./flags/flag_eritrea.png": "eddc",
	"./flags/flag_estonia.png": "f556",
	"./flags/flag_ethiopia.png": "1247",
	"./flags/flag_falkland_islands.png": "c503",
	"./flags/flag_faroe_islands.png": "0075",
	"./flags/flag_fiji.png": "6b67",
	"./flags/flag_finland.png": "2ad6",
	"./flags/flag_france.png": "67d8",
	"./flags/flag_french_polynesia.png": "aaa4",
	"./flags/flag_gabon.png": "ba86",
	"./flags/flag_gambia.png": "f018",
	"./flags/flag_georgia.png": "2dac",
	"./flags/flag_germany.png": "660a",
	"./flags/flag_ghana.png": "a224",
	"./flags/flag_gibraltar.png": "618a",
	"./flags/flag_greece.png": "d1ee",
	"./flags/flag_greenland.png": "9edc",
	"./flags/flag_grenada.png": "49d0",
	"./flags/flag_guadeloupe.png": "15f6",
	"./flags/flag_guam.png": "fe30",
	"./flags/flag_guatemala.png": "4e51",
	"./flags/flag_guernsey.png": "bbb8",
	"./flags/flag_guinea.png": "938a",
	"./flags/flag_guinea_bissau.png": "f477",
	"./flags/flag_guyana.png": "4d2e",
	"./flags/flag_guyane.png": "b8e4",
	"./flags/flag_haiti.png": "0c16",
	"./flags/flag_honduras.png": "9668",
	"./flags/flag_hong_kong.png": "c778",
	"./flags/flag_hungary.png": "cb26",
	"./flags/flag_iceland.png": "8be5",
	"./flags/flag_india.png": "4f6a",
	"./flags/flag_indonesia.png": "66bd",
	"./flags/flag_iran.png": "386d",
	"./flags/flag_iraq.png": "9c82",
	"./flags/flag_iraq_new.png": "40b1",
	"./flags/flag_ireland.png": "93f9",
	"./flags/flag_isleof_man.png": "0974",
	"./flags/flag_israel.png": "8f43",
	"./flags/flag_italy.png": "2eb3",
	"./flags/flag_jamaica.png": "ed6b",
	"./flags/flag_japan.png": "1a0a",
	"./flags/flag_jersey.png": "ce41",
	"./flags/flag_jordan.png": "a1ce",
	"./flags/flag_kazakhstan.png": "261c",
	"./flags/flag_kenya.png": "f4d5",
	"./flags/flag_kiribati.png": "73d6",
	"./flags/flag_kosovo.png": "195f",
	"./flags/flag_kuwait.png": "8ba3",
	"./flags/flag_kyrgyzstan.png": "70e2",
	"./flags/flag_laos.png": "1e79",
	"./flags/flag_latvia.png": "ba66",
	"./flags/flag_lebanon.png": "2d51",
	"./flags/flag_lesotho.png": "5716",
	"./flags/flag_liberia.png": "60ea",
	"./flags/flag_libya.png": "b88c",
	"./flags/flag_liechtenstein.png": "f8ed",
	"./flags/flag_lithuania.png": "6e0e",
	"./flags/flag_luxembourg.png": "05bd",
	"./flags/flag_macao.png": "ca62",
	"./flags/flag_macedonia.png": "9d8a",
	"./flags/flag_madagascar.png": "b463",
	"./flags/flag_malawi.png": "4d95",
	"./flags/flag_malaysia.png": "ed5a",
	"./flags/flag_maldives.png": "89ec",
	"./flags/flag_mali.png": "8d95",
	"./flags/flag_malta.png": "8bcd",
	"./flags/flag_marshall_islands.png": "14d2",
	"./flags/flag_martinique.png": "4a87",
	"./flags/flag_mauritania.png": "c7f8",
	"./flags/flag_mauritius.png": "ef14",
	"./flags/flag_mexico.png": "64bf",
	"./flags/flag_micronesia.png": "d80f",
	"./flags/flag_moldova.png": "3cc3",
	"./flags/flag_monaco.png": "a8bf",
	"./flags/flag_mongolia.png": "86b1",
	"./flags/flag_montserrat.png": "5665",
	"./flags/flag_morocco.png": "10e1",
	"./flags/flag_mozambique.png": "591e",
	"./flags/flag_myanmar.png": "b22e",
	"./flags/flag_namibia.png": "032e",
	"./flags/flag_nauru.png": "2308",
	"./flags/flag_nepal.png": "eb50",
	"./flags/flag_netherlands.png": "90fa",
	"./flags/flag_netherlands_antilles.png": "52ed",
	"./flags/flag_new_caledonia.png": "074c",
	"./flags/flag_new_zealand.png": "44ae",
	"./flags/flag_nicaragua.png": "072f",
	"./flags/flag_niger.png": "8af6",
	"./flags/flag_nigeria.png": "367b",
	"./flags/flag_niue.png": "a810",
	"./flags/flag_norfolk_island.png": "e5f6",
	"./flags/flag_north_korea.png": "df8a",
	"./flags/flag_northern_mariana_islands.png": "b74a",
	"./flags/flag_norway.png": "7fc8",
	"./flags/flag_of_montenegro.png": "56ae",
	"./flags/flag_oman.png": "205e",
	"./flags/flag_pakistan.png": "0ad7",
	"./flags/flag_palau.png": "6168",
	"./flags/flag_palestine.png": "d2cc",
	"./flags/flag_panama.png": "2678",
	"./flags/flag_papua_new_guinea.png": "be93",
	"./flags/flag_paraguay.png": "af39",
	"./flags/flag_peru.png": "8cc3",
	"./flags/flag_philippines.png": "1c6c",
	"./flags/flag_pitcairn_islands.png": "a8d7",
	"./flags/flag_poland.png": "d2bf",
	"./flags/flag_portugal.png": "1207",
	"./flags/flag_puerto_rico.png": "bac2",
	"./flags/flag_qatar.png": "34fa",
	"./flags/flag_republic_of_the_congo.png": "31b6",
	"./flags/flag_romania.png": "ea55",
	"./flags/flag_russian_federation.png": "7413",
	"./flags/flag_rwanda.png": "3638",
	"./flags/flag_saint_barthelemy.png": "cac4",
	"./flags/flag_saint_helena.png": "3212",
	"./flags/flag_saint_kitts_and_nevis.png": "5317",
	"./flags/flag_saint_lucia.png": "506e",
	"./flags/flag_saint_martin.png": "a1f5",
	"./flags/flag_saint_pierre.png": "cd12",
	"./flags/flag_saint_vicent_and_the_grenadines.png": "ccad",
	"./flags/flag_samoa.png": "e011",
	"./flags/flag_san_marino.png": "bb9c",
	"./flags/flag_sao_tome_and_principe.png": "1354",
	"./flags/flag_saudi_arabia.png": "fa15",
	"./flags/flag_senegal.png": "2773",
	"./flags/flag_serbia.png": "d607",
	"./flags/flag_serbia_and_montenegro.png": "c10b",
	"./flags/flag_seychelles.png": "b0ba",
	"./flags/flag_sierra_leone.png": "698a",
	"./flags/flag_singapore.png": "5ed0",
	"./flags/flag_sint_maarten.png": "5ec9",
	"./flags/flag_slovakia.png": "041e",
	"./flags/flag_slovenia.png": "fcfd",
	"./flags/flag_soloman_islands.png": "5166",
	"./flags/flag_somalia.png": "b1c0",
	"./flags/flag_south_africa.png": "4d83",
	"./flags/flag_south_georgia.png": "0e4f",
	"./flags/flag_south_korea.png": "0b8f",
	"./flags/flag_south_sudan.png": "11a6",
	"./flags/flag_soviet_union.png": "6edd",
	"./flags/flag_spain.png": "fc7f",
	"./flags/flag_sri_lanka.png": "cf10",
	"./flags/flag_sudan.png": "234f",
	"./flags/flag_suriname.png": "23db",
	"./flags/flag_swaziland.png": "e5f4",
	"./flags/flag_sweden.png": "d31c",
	"./flags/flag_switzerland.png": "baa7",
	"./flags/flag_syria.png": "9ace",
	"./flags/flag_taiwan.png": "93b9",
	"./flags/flag_tajikistan.png": "3660",
	"./flags/flag_tanzania.png": "9be8",
	"./flags/flag_thailand.png": "cdae",
	"./flags/flag_tibet.png": "1f83",
	"./flags/flag_timor_leste.png": "85e2",
	"./flags/flag_togo.png": "591b",
	"./flags/flag_tokelau.png": "f95f",
	"./flags/flag_tonga.png": "7b34",
	"./flags/flag_transparent.png": "5e5e",
	"./flags/flag_trinidad_and_tobago.png": "a68c",
	"./flags/flag_tunisia.png": "4ae3",
	"./flags/flag_turkey.png": "e9d3",
	"./flags/flag_turkmenistan.png": "1cc3",
	"./flags/flag_turks_and_caicos_islands.png": "af04",
	"./flags/flag_tuvalu.png": "9620",
	"./flags/flag_uae.png": "6d3c",
	"./flags/flag_uganda.png": "3094",
	"./flags/flag_ukraine.png": "2b5c",
	"./flags/flag_united_kingdom.png": "49e4",
	"./flags/flag_united_states_of_america.png": "9249",
	"./flags/flag_uruguay.png": "7c12",
	"./flags/flag_us_virgin_islands.png": "7040",
	"./flags/flag_uzbekistan.png": "c614",
	"./flags/flag_vanuatu.png": "a8d4",
	"./flags/flag_vatican_city.png": "d5be",
	"./flags/flag_venezuela.png": "e4e1",
	"./flags/flag_vietnam.png": "a14d",
	"./flags/flag_wallis_and_futuna.png": "1cd9",
	"./flags/flag_yemen.png": "1936",
	"./flags/flag_zambia.png": "ba34",
	"./flags/flag_zimbabwe.png": "aee6",
	"./gift-light.png": "3b9c",
	"./gold_coins.png": "5e46",
	"./gold_shine.png": "51d6",
	"./liveflamingo.png": "00cd",
	"./liveflamingo@2x.png": "60fc",
	"./login-right.png": "0d51c",
	"./phone-mockup.png": "ca9c",
	"./profile-report-icon.png": "3a0c",
	"./profile-share-icon.png": "2935",
	"./profile-status-icon.png": "7348",
	"./red.png": "94f9",
	"./red@2x.png": "da46",
	"./safety/close.png": "875e",
	"./safety/img1-1.png": "a1e8",
	"./safety/img1-2.png": "e60f",
	"./safety/img1-3.png": "3392",
	"./safety/img1-4.png": "416d",
	"./safety/img1-5.png": "5d1e",
	"./safety/img2-1.png": "2ff8",
	"./safety/img2-2.png": "157f",
	"./safety/img2-3.png": "af51",
	"./safety/img2-4.png": "ad44",
	"./safety/img2-5.png": "5276",
	"./safety/img2-6.png": "02b0",
	"./safety/img2-7.png": "4e76",
	"./safety/img3-1.png": "3a48",
	"./safety/img3-2.png": "402c",
	"./safety/img3-3.png": "00e3",
	"./safety/img3-4.png": "b45b",
	"./safety/img3-5.png": "3050",
	"./safety/img3-6.png": "6ac2",
	"./safety/img3-7.png": "ccc5",
	"./safety/large-1.png": "42a5",
	"./safety/large-2.png": "30fe",
	"./safety/large-3.png": "2fb7",
	"./safety/mail.png": "a7979",
	"./safety/menu-icon-light.png": "97c1",
	"./safety/menu-icon.png": "25f2",
	"./safety/xia.png": "1d4e",
	"./silver_shine.png": "ca1e",
	"./stream-1.png": "43c0",
	"./stream-2.png": "e6cd",
	"./stream-3.png": "5b35",
	"./superlive.png": "4a7f",
	"./superlive@2x.png": "cc6a",
	"./users_liveflamingo.png": "9df3",
	"./users_red.png": "30d0",
	"./users_superlive.png": "6cc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";